import { CanvasWhiteboardShape, CanvasWhiteboardUpdate, CanvasWhiteboardComponent } from "ng2-canvas-whiteboard";
import { paintBucket } from "../../../../helpers/image-helper";

let ctx         : CanvasRenderingContext2D;
let component   : CanvasWhiteboardComponent;
let updates     : { ID: string, fillColor: number[] }[] = [];
let image :HTMLImageElement;

export function getPaintBucketShapeClass(context: CanvasRenderingContext2D, c: CanvasWhiteboardComponent) {
    component = c;
    ctx = (component.canvas.nativeElement as HTMLCanvasElement).getContext('2d');
    return PaintBucketShape;
}
export class PaintBucketShape extends CanvasWhiteboardShape {
    getShapeName(): string {
      return "PaintBucketShape";
    }

    linePositions = [];
    fillColor: number[];

    constructor(positionPoint, options) {
        super(positionPoint, options);

        this.fillColor = component.fillColor
            .substring(5, component.fillColor.length - 1)
            .split(',')
            .map(_ => parseInt(_));

        image =new Image();
        image.src="/Style Library/images/bucket3.png";
    }

    drawPreview(context: CanvasRenderingContext2D) { 
        context.fillStyle =component.fillColor;
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        context.drawImage(image,context.canvas.width/2-image.width / 2, context.canvas.height/2- image.height / 2)
        this.draw(context);
    }
    onUpdateReceived(update: CanvasWhiteboardUpdate) {}

    draw(context: CanvasRenderingContext2D) {
        Object.assign(context, this.options);
    }

    onStopReceived(update: CanvasWhiteboardUpdate) {
        let existing = updates.find(_ => _.ID == update.UUID);
        if (existing && existing.fillColor)
         { this.fillColor = existing.fillColor; }       
         updates.push({ ID: update.UUID, fillColor: this.fillColor });
        paintBucket(ctx, update.x, update.y, this.fillColor);
    }

}
